<template>
     <svg class="svg-inline--fa fa-w-16" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg"><path d="M5 21H3V11h2Zm6-14H9v18h2Zm6-5h-2v28h2Zm6 9h-2v10h2Zm6-4h-2v18h2Z" data-name="1" fill="currentColor" class="fill-000000"></path></svg>
</template>